import React, { useContext, useState } from 'react';
// import MenuAnalises from './menuAnalises';
// import AnalisesContext from './AnalisesContext';
import ExcelReader from './ExcelReader';
import DayAnalyzer from './DayAnalizer';
import DayAnalyzerBltXPlano from './DayAnalizerBltxPlano';
import ImpRealDia from './impRealDia';
import {Tabs, Tab, Box} from '@mui/material';

const AnaliseProducao = () => {
  // const { showImportBoletim, showAnaliseDia, showBltxPlano } = useContext(AnalisesContext)
  const [realDia, setRealDia] = useState(null)

  const [tabIndex, setTabIndex] = useState(0);

  const tabs = [
    {label: 'Dados Dia', component: <ImpRealDia setRealDia={setRealDia} realDia={realDia}/>},
    {label: 'Imp. Boletim', component: <ExcelReader/>},
    {label: 'Analise Dia', component: <DayAnalyzer/>},
    {label: 'Real x Plano', component: <DayAnalyzerBltXPlano/>},
  ]

  const handleTabChange = (_, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <Box display="flex" flexDirection="column" width="100%">

      <Tabs value={tabIndex}  onChange={handleTabChange} sx={{ mt: 0 }}>
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ mt: 0 }}>
        {tabs[tabIndex].component}
      </Box>
    </Box>
  )
}

export default AnaliseProducao